import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
import { ref } from 'vue';
import router from '@/router';
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItem',
  props: {
    menuList: {}
  },
  setup(__props) {
    const showTooltip = ref(false);
    const handleMenuClick = name => {
      router.push({
        name
      });
    };
    // 判断是否显示tooltip
    const hoverMenu = e => {
      const target = e.target;
      // 判断文本是否溢出
      showTooltip.value = target.scrollWidth > target.clientWidth;
    };
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_MenuItem = _resolveComponent("MenuItem", true);
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, menu => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: menu.id
        }, [menu.children && menu.children.length > 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
          key: 0,
          index: menu.name + ''
        }, {
          title: _withCtx(() => [menu.meta.icon ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(['iconfont', 'menu-icon', 'icon-r-' + menu.meta.icon])
          }, null, 2)) : _createCommentVNode("", true), _createVNode(_component_el_tooltip, {
            effect: "light",
            content: menu.meta.title,
            placement: "top-start",
            offset: -10,
            disabled: !showTooltip.value
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              ref_for: true,
              ref: "menuTextRef",
              class: "menu-label",
              onMouseover: hoverMenu
            }, _toDisplayString(menu.meta.title), 545)]),
            _: 2
          }, 1032, ["content", "disabled"])]),
          default: _withCtx(() => [_createVNode(_component_MenuItem, {
            menuList: menu.children
          }, null, 8, ["menuList"])]),
          _: 2
        }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 1,
          index: menu.name + '',
          onClick: $event => handleMenuClick(menu.name)
        }, {
          title: _withCtx(() => [_createVNode(_component_el_tooltip, {
            effect: "light",
            content: menu.meta.title,
            placement: "top-start",
            offset: -10,
            disabled: !showTooltip.value
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              ref_for: true,
              ref: "menuTextRef",
              class: "menu-label",
              onMouseover: hoverMenu
            }, _toDisplayString(menu.meta.title), 545)]),
            _: 2
          }, 1032, ["content", "disabled"])]),
          default: _withCtx(() => [menu.meta.icon ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(['iconfont', 'menu-icon', 'icon-r-' + menu.meta.icon])
          }, null, 2)) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["index", "onClick"]))], 64);
      }), 128);
    };
  }
});